import React from 'react';
import PropTypes from 'prop-types';
import securityService from 'core/security/securityService';
import {SecurableComponentProps} from "core/metamodel/metaConstant";
import {OBJECTMAP} from "core/common/domain/commonDomain";
import {observer} from "mobx-react";
import PageAncestor from "../../common/page/pageAncestor";



export function disabledHoc(Component) {
    return class extends React.Component<SecurableComponentProps & OBJECTMAP<any>, any> {

      static contextTypes = {
        router: PropTypes.func.isRequired
      };

      state = {enabled: true};

      componentWillMount() {
        const {module, securableType, securable, permission, detailId} = this.props;
        this.setState({
          enabled: securityService.hasRouterRight(this.context.router, module, securableType, securable, permission, detailId)
        });
      }

      render() {
        const {module, securableType, securable, permission, disabled, ...other} = this.props;

        return <Component {...other} disabled={!this.state.enabled || disabled}/>;
      }
    };
}


export function withDeleteDialogHoc(Component) {
  return class extends React.Component<{ entityName: string, pageAncestor: PageAncestor<any, any>, onClick: any } & OBJECTMAP<any>, any> {

    handleClick = (e) => {
      const {entityName, pageAncestor, onClick} = this.props;
      console.debug("onClick for withDeleteDialogHoc button on entity " + entityName);

      if (securityService.currentUser.confirmDelete(entityName)) {
        pageAncestor.openDeleteDialog().then(() => {
          onClick();
        }).catch((e) => {});
      } else {
        onClick();
      }
    }

    render() {
      const {entityName, pageAncestor, onClick, ...other} = this.props;
      return <Component onClick={this.handleClick} {...other}/>;
    }

  };
}



// WEBPACK FOOTER //
// ./src/core/security/component/disabledHoc.tsx